import React, { PropsWithChildren } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import enhanceMessage from './enhanceMessage';
import { TwilioError } from 'twilio-video';
import { networkErrorCodes } from '../../constants';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

interface ErrorDialogProps {
  dismissError: Function;
  error: TwilioError | null;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      color: '#3498DB',
    },
  })
);

function ErrorDialog({ dismissError, error }: PropsWithChildren<ErrorDialogProps>) {
  const { message, code } = error || {};
  const { setNetworkError } = useVideoContext();
  const enhancedMessage = enhanceMessage(message, code);
  const networkError = 'You are Offline. Please reload once you are back Online.';
  const classes = useStyles();
  const isNetworkIssue = networkErrorCodes.includes(code) || enhancedMessage === 'Network Error';

  if (isNetworkIssue) setNetworkError(true);

  return (
    <Dialog open={error !== null} onClose={() => dismissError()} fullWidth={true} maxWidth="xs">
      <DialogTitle>Oops!</DialogTitle>
      <DialogContent>
        <DialogContentText>{isNetworkIssue ? networkError : enhancedMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => dismissError()} className={classes.button} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ErrorDialog;
